<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowledgments" id="ack">
<p class="chapterTitle1">Acknowledgements</p>
<p class="paraNoIndent1">Help with this book has come from several kind people who have given time, photographs and assistance with the project. Many thanks therefore go to: Paul Baillie, John Larder (BoB Historical Society), Andy Saunders, Chris Shores, Andy Thomas, Barry Weekley, Mrs K Wright and her daughter Sarah, and the late Fred Woodgate.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_TallyHo_acknowledgment.vue?175579dd